<template>
  <div>
    <h2>Remodeling Budget Calculator</h2>
    <p>
      What is your home value?
      <span style="display: inline-block"
        ><DollarBox v-model="homeValue"></DollarBox
      ></span>
    </p>
    <template v-if="view == 'kitchen'">
      <h3>Kitchen Budget</h3>
      <p>
        Calculate your total remodeling budget. The National Kitchen &amp; Bath
        Association (NKBA) recommends remodeling a kitchen with a budget of
        10-25% of your home’s value.
      </p>
      <table>
        <thead>
          <tr>
            <th>NKBA Recommended Percent</th>
            <th>Enter a Percent</th>
            <th>Estimated Budget</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><input :readonly="true" :value="'10%-25%'" /></td>
            <td><DollarBox type="percent" v-model="kitchenPercent" /></td>
            <td><DollarBox :readonly="true" v-model="kitchenBudget" /></td>
          </tr>
        </tbody>
      </table>
      <p>
        Calculate the budget for each component. Below, we’ve listed what the
        NKBA recommends to spend on each component, as a percentage of the total
        budget.
      </p>
      <table>
        <thead>
          <tr>
            <th>Product</th>
            <th>NKBA Recommended Percent</th>
            <th>Enter a Percent</th>
            <th>Estimated Budget</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, id) in kitchenItems" :key="id">
            <td>{{ item.name }}</td>
            <td>
              <DollarBox
                :readonly="true"
                type="percent"
                :modelValue="item.rec"
              />
            </td>
            <td>
              <DollarBox type="percent" v-model="kitchenItems[id].percent" />
            </td>
            <td>
              <DollarBox
                :readonly="true"
                :modelValue="(kitchenItems[id].percent * kitchenBudget) / 100"
              />
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th colspan="3">Estimated Total Kitchen Budget</th>
            <td><DollarBox :readonly="true" :modelValue="kitchenTotal" /></td>
          </tr>
        </tfoot>
      </table>
    </template>
    <template v-if="view == 'bathroom'">
      <h3>Bathroom Budget</h3>
      <p>
        Calculate your total remodeling budget. The National Kitchen &amp; Bath
        Association (NKBA) recommends remodeling a bath with a budget of 5-10%
        of your home’s value.
      </p>
      <table>
        <thead>
          <tr>
            <th>NKBA Recommended Percent</th>
            <th>Enter a Percent</th>
            <th>Estimated Budget</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><input :readonly="true" :value="'5%-10%'" /></td>
            <td><DollarBox type="percent" v-model="bathroomPercent" /></td>
            <td><DollarBox :readonly="true" v-model="bathroomBudget" /></td>
          </tr>
        </tbody>
      </table>
      <p>
        Calculate the budget for each component. Below, we’ve listed what the
        NKBA recommends to spend on each component, as a percentage of the total
        budget.
      </p>
      <table>
        <thead>
          <tr>
            <th>Product</th>
            <th>NKBA Recommended Percent</th>
            <th>Enter a Percent</th>
            <th>Estimated Budget</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, id) in bathroomItems" :key="id">
            <td>{{ item.name }}</td>
            <td>
              <DollarBox
                :readonly="true"
                type="percent"
                :modelValue="item.rec"
              />
            </td>
            <td>
              <DollarBox type="percent" v-model="bathroomItems[id].percent" />
            </td>
            <td>
              <DollarBox
                :readonly="true"
                :modelValue="(bathroomItems[id].percent * bathroomBudget) / 100"
              />
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th colspan="3">Estimated Total Bathroom Budget</th>
            <td><DollarBox :readonly="true" :modelValue="bathroomTotal" /></td>
          </tr>
        </tfoot>
      </table>
    </template>
  </div>
</template>

<script>
import DollarBox from "./Dollarbox.vue";
export default {
  name: "Budget",
  components: {
    DollarBox,
  },
  props: {
    view: String,
  },
  data() {
    return {
      homeValue: 200000,
      kitchenPercent: 18,
      kitchenItems: [
        { name: "Cabinetry", percent: 35, rec: 35 },
        { name: "Countertops", percent: 11, rec: 11 },
        { name: "Appliances", percent: 12, rec: 12 },
        { name: "Lighting/Electrical", percent: 9, rec: 9 },
        { name: "Wall Covering", percent: 3, rec: 3 },
        { name: "Floor Covering", percent: 7, rec: 7 },
        { name: "Plumbing", percent: 3, rec: 3 },
        { name: "Labor", percent: 20, rec: 20 },
      ],
      bathroomPercent: 10,
      bathroomItems: [
        { name: "Cabinetry", percent: 35, rec: 35 },
        { name: "Countertops", percent: 11, rec: 11 },
        { name: "Appliances", percent: 12, rec: 12 },
        { name: "Lighting/Electrical", percent: 9, rec: 9 },
        { name: "Wall Covering", percent: 3, rec: 3 },
        { name: "Floor Covering", percent: 7, rec: 7 },
        { name: "Plumbing", percent: 3, rec: 3 },
        { name: "Labor", percent: 20, rec: 20 },
      ],
    };
  },
  computed: {
    kitchenBudget() {
      return (this.homeValue * this.kitchenPercent) / 100;
    },
    kitchenTotal() {
      var total = 0;
      for (var item of this.kitchenItems) {
        total += (item.percent * this.kitchenBudget) / 100;
      }
      return total;
    },
    bathroomBudget() {
      return (this.homeValue * this.bathroomPercent) / 100;
    },
    bathroomTotal() {
      var total = 0;
      for (var item of this.bathroomItems) {
        total += (item.percent * this.bathroomBudget) / 100;
      }
      return total;
    },
  },
};
</script>

<style scoped>
</style>
